var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-10 0 262.343 185.511"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "page-error_svg__clip-path-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h242.343v185.511H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "page-error_svg__clip-path-b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h76.436v117.698H0z",
    transform: "translate(165.907 6.794)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "page-error_svg__clip-path-c"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#page-error_svg__reuse-0",
    transform: "translate(205.343 96.643)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "page-error_svg__clip-path-d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h10.501v10.5H0z",
    transform: "translate(189.458 93.531)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "page-error_svg__clip-path-e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#page-error_svg__reuse-0",
    transform: "translate(174.728 120.518)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "page-error_svg__clip-path-f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h10.501v10.499H0z",
    transform: "translate(158.843 117.407)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "page-error_svg__clip-path-g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h74v73.993H0z",
    transform: "translate(1.728 111.518)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "page-error_svg__reuse-0",
    fill: "none",
    d: "M0 0h29v6H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#page-error_svg__clip-path-a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#page-error_svg__clip-path-a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-animation-class": "scale-in"
  }, /*#__PURE__*/React.createElement("g", {
    "data-animation-class": "fade-in",
    "data-animation-delay": 700
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    "data-animation-class": "slide-in-up-right",
    "data-animation-delay": 700
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2b3236",
    d: "M239.343 7.294v116.7a7.294 7.294 0 01-7.294 7.294h-65.642a7.294 7.294 0 01-7.294-7.294V7.294A7.294 7.294 0 01166.407 0h65.642a7.294 7.294 0 017.294 7.294"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#page-error_svg__clip-path-b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4f5558",
    d: "M166.406 7.294h65.643v116.698h-65.643z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-animation-class": "slide-in-left",
    "data-animation-delay": 300
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff2741",
    d: "M194.343 87.643h45.429a2.571 2.571 0 012.571 2.571v18.858a2.571 2.571 0 01-2.571 2.571h-45.429a12 12 0 010-24"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#page-error_svg__clip-path-c)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#10181c",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M208.343 99.643h23"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#10181c",
    strokeWidth: 1.5,
    clipPath: "url(#page-error_svg__clip-path-d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.708 101.594a.281.281 0 010-.562M194.708 101.594a.281.281 0 100-.562"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M194.708 99.344v-2.25M199.068 101.355a1.315 1.315 0 01.139.655 1.329 1.329 0 01-1.329 1.271h-6.339a1.333 1.333 0 01-1.19-1.931l3.169-6.333a1.331 1.331 0 012.381 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#57d33b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.271 34.66a22.547 22.547 0 00-3.8-.335c-4.509 0-8.337 1.524-10.781 4.293a10.957 10.957 0 00-2.579 8.752c.8 6.377 7.345 18.273 17.024 18.273 9.283 0 17.116-11.266 17.116-18.343 0-6.181-6.187-10.789-16.976-12.64m13.154 9.4a5.847 5.847 0 01.952 3.239 12.466 12.466 0 01-1.121 4.69 21.343 21.343 0 01-3.205 5.228 17.739 17.739 0 01-4.642 4.024 9.659 9.659 0 01-10.386.013 16.875 16.875 0 01-4.424-4.018 22.493 22.493 0 01-4.64-10.228 8.634 8.634 0 01.267-3.581 7.75 7.75 0 011.619-2.915c1.889-2.14 4.951-3.319 8.62-3.319a19.688 19.688 0 013.323.3 28.458 28.458 0 0110.735 3.769 9.8 9.8 0 012.9 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.681 43.984a2.238 2.238 0 102.238-2.238 2.24 2.24 0 00-2.238 2.238M193.771 45.577a2.239 2.239 0 11-2.238 2.238 2.238 2.238 0 012.238-2.238M204.069 45.577a2.239 2.239 0 11-2.238 2.238 2.238 2.238 0 012.238-2.238M202.125 51.535a2.239 2.239 0 102.238 2.239 2.241 2.241 0 00-2.238-2.239M195.713 51.535a2.239 2.239 0 102.239 2.239 2.241 2.241 0 00-2.239-2.239"
  })))))), /*#__PURE__*/React.createElement("path", {
    fill: "#2b3236",
    d: "M38.728 42.518h160a10 10 0 0110 10v90a10 10 0 01-10 10h-160a10 10 0 01-10-10v-90a10 10 0 0110-10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4f5558",
    d: "M38.728 52.518h160v90h-160z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-animation-class": "slide-in-left",
    "data-animation-delay": 400
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff2741",
    d: "M163.728 111.518h45.429a2.571 2.571 0 012.571 2.571v18.858a2.571 2.571 0 01-2.571 2.571h-45.429a12 12 0 010-24"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#page-error_svg__clip-path-e)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#10181c",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M177.728 123.518h23"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#10181c",
    strokeWidth: 1.5,
    clipPath: "url(#page-error_svg__clip-path-f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.093 125.469a.281.281 0 110-.562M164.093 125.469a.281.281 0 000-.562"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M164.093 123.219v-2.25M168.453 125.23a1.315 1.315 0 01.139.655 1.329 1.329 0 01-1.329 1.271h-6.339a1.333 1.333 0 01-1.19-1.931l3.169-6.333a1.331 1.331 0 012.381 0z"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#57d33b",
    clipPath: "url(#page-error_svg__clip-path-a)",
    "data-animation-class": "scale-in",
    "data-animation-delay": 300
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.771 82.194a22.547 22.547 0 00-3.8-.335c-4.509 0-8.337 1.524-10.781 4.293a10.957 10.957 0 00-2.579 8.752c.8 6.377 7.345 18.273 17.024 18.273 9.283 0 17.116-11.266 17.116-18.343 0-6.181-6.187-10.789-16.976-12.64m13.154 9.4a5.847 5.847 0 01.952 3.239 12.466 12.466 0 01-1.121 4.69 21.343 21.343 0 01-3.205 5.228 17.739 17.739 0 01-4.642 4.024 9.659 9.659 0 01-10.386.013 16.875 16.875 0 01-4.424-4.018 22.493 22.493 0 01-4.64-10.228 8.634 8.634 0 01.267-3.581 7.75 7.75 0 011.619-2.915c1.889-2.14 4.951-3.319 8.62-3.319a19.688 19.688 0 013.323.295 28.458 28.458 0 0110.735 3.769 9.8 9.8 0 012.9 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.181 91.518a2.238 2.238 0 102.238-2.238 2.24 2.24 0 00-2.238 2.238M113.271 93.112a2.238 2.238 0 11-2.238 2.238 2.238 2.238 0 012.238-2.238M123.569 93.112a2.238 2.238 0 11-2.238 2.238 2.238 2.238 0 012.238-2.238M121.626 99.069a2.238 2.238 0 102.238 2.239 2.242 2.242 0 00-2.238-2.239M115.213 99.069a2.238 2.238 0 102.239 2.239 2.241 2.241 0 00-2.239-2.239"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ff2741",
    strokeWidth: 3,
    clipPath: "url(#page-error_svg__clip-path-g)",
    "data-animation-class": "scale-in",
    "data-animation-delay": 100
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.725 167.219a.861.861 0 110-1.722M38.724 167.219a.861.861 0 100-1.722"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M38.728 152.48v-15.856M69.449 166.653a9.38 9.38 0 01-8.388 13.573H16.392a9.377 9.377 0 01-8.386-13.573l22.332-44.663a9.381 9.381 0 0116.779 0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#page-error_svg__clip-path-a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-animation-class": "splat",
    "data-animation-delay": 700
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#737c81",
    d: "M2.6 46.526a2 2 0 01-1.094-2.543c.286-1.19 1.24-1.982 2.13-1.768s16.982 5.729 16.839 6.326c-.158.656-16.985-1.8-17.875-2.015",
    "data-animation-class": "pulse-opacity",
    "data-animation-delay": 500
  })), /*#__PURE__*/React.createElement("g", {
    "data-animation-class": "splat",
    "data-animation-delay": 800
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#737c81",
    d: "M2.286 24.7c-1.262-.969-1.686-2.541-.938-3.513s2.371-.976 3.634-.009S28.625 41.3 28.251 41.791c-.41.536-24.7-16.126-25.965-17.093",
    "data-animation-class": "pulse-opacity",
    "data-animation-delay": 500
  })), /*#__PURE__*/React.createElement("g", {
    "data-animation-class": "splat",
    "data-animation-delay": 900
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#737c81",
    d: "M22.376 16.768a2.021 2.021 0 011.168-2.568 2.021 2.021 0 012.768.522c.442.852 7.192 17.35 6.647 17.632-.6.311-10.141-14.739-10.583-15.591",
    "data-animation-class": "pulse-opacity",
    "data-animation-delay": 500
  })), /*#__PURE__*/React.createElement("g", {
    "data-animation-class": "splat",
    "data-animation-delay": 900
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#737c81",
    d: "M225.438 17.206a1.481 1.481 0 012.5 1.357c-.28.515-6.365 9.562-6.711 9.374-.38-.207 3.934-10.215 4.215-10.731",
    "data-animation-class": "pulse-opacity",
    "data-animation-delay": 500,
    "data-animation-transform-origin": "left bottom"
  })), /*#__PURE__*/React.createElement("g", {
    "data-animation-class": "splat",
    "data-animation-delay": 800
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#737c81",
    d: "M239 20.633a1.676 1.676 0 012.329 0 1.675 1.675 0 01-.6 2.251c-.809.621-16.383 11.3-16.622 10.984-.264-.343 14.082-12.616 14.89-13.237",
    "data-animation-class": "pulse-opacity",
    "data-animation-delay": 400,
    "data-animation-transform-origin": "left bottom"
  })), /*#__PURE__*/React.createElement("g", {
    "data-animation-class": "splat",
    "data-animation-delay": 700
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#737c81",
    d: "M240.577 34.385a1.463 1.463 0 01.61 2.775c-.6.132-11.933 1.573-12.018 1.189-.093-.423 10.807-3.832 11.408-3.964",
    "data-animation-class": "pulse-opacity",
    "data-animation-delay": 500,
    "data-animation-transform-origin": "left bottom"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ff2741",
    d: "M48.7 60.893a1.975 1.975 0 10-1.975 1.975 1.975 1.975 0 001.975-1.975"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7600",
    d: "M55.832 60.893a1.975 1.975 0 10-1.975 1.975 1.975 1.975 0 001.975-1.975"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57d33b",
    d: "M62.961 60.893a1.975 1.975 0 10-1.975 1.975 1.975 1.975 0 001.975-1.975"
  })))));
}
export default __webpack_public_path__ + "static/page-error.ccd76b0c.svg";
export { SvgPageError as ReactComponent };